import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, UsersIcon, HeartIcon, MessageCircleIcon, StarIcon } from 'lucide-react';
export function MethodSection() {
  const pillars = [{
    letter: 'C',
    title: 'Cunoaștere',
    icon: <BookOpenIcon size={24} className="text-brand-navy" strokeWidth={1.5} data-id="element-228" />,
    desc: 'Înțelegi etapele reale de dezvoltare ale copilului tău. Înveți să deosebești ce e normal de ce e semn de alarmă, ca să știi exact unde e copilul tău și ce are nevoie acum.'
  }, {
    letter: 'R',
    title: 'Relaționare',
    icon: <UsersIcon size={24} className="text-brand-navy" strokeWidth={1.5} data-id="element-229" />,
    desc: 'Înveți să construiești conexiunea cu copilul tău prin contact vizual, atenție împărtășită, imitare și joc. Aici se pune baza pe care se clădește tot restul dezvoltării.'
  }, {
    letter: 'E',
    title: 'Emoții',
    icon: <HeartIcon size={24} className="text-brand-navy" strokeWidth={1.5} data-id="element-230" />,
    desc: 'Înveți cum să gestionezi crizele de nervi, refuzul și frustrările copilului. Descoperi cum să îl ajuți să își regleze emoțiile și să accepte limitele, fără să te simți depășită.'
  }, {
    letter: 'S',
    title: 'Structurarea comunicării',
    icon: <MessageCircleIcon size={24} className="text-brand-navy" strokeWidth={1.5} data-id="element-231" />,
    desc: 'Copilul învață să înțeleagă ce i se spune, să ceară ce are nevoie și să înceapă să comunice funcțional. Lucrezi pe limbajul receptiv și expresiv, pas cu pas, în viața de zi cu zi.'
  }, {
    letter: 'C',
    title: 'Comportament și autonomie',
    icon: <StarIcon size={24} className="text-brand-navy" strokeWidth={1.5} data-id="element-232" />,
    desc: 'Copilul învață autoservirea, rutinele zilnice, mersul la toaletă și respectarea regulilor potrivite vârstei. Îl pregătești pentru următoarea etapă: grădinița și viața socială.'
  }];
  return <section id="metoda" className="bg-brand-navy section-padding text-white relative overflow-hidden" data-id="element-233">
      {/* Decorative Background Elements */}
      <div className="absolute top-0 right-0 w-[800px] h-[800px] rounded-full border-[1px] border-white/5 -translate-y-1/2 translate-x-1/3 pointer-events-none" data-id="element-234"></div>
      <div className="absolute top-20 right-20 w-[600px] h-[600px] rounded-full border-[1px] border-white/5 -translate-y-1/2 translate-x-1/3 pointer-events-none" data-id="element-235"></div>

      <svg className="absolute bottom-10 left-10 w-48 h-48 text-white/5 pointer-events-none" viewBox="0 0 100 100" data-id="element-236">
        <defs data-id="element-237">
          <pattern id="dots-method" x="0" y="0" width="10" height="10" patternUnits="userSpaceOnUse" data-id="element-238">
            <circle cx="2" cy="2" r="1.5" fill="currentColor" data-id="element-239" />
          </pattern>
        </defs>
        <rect x="0" y="0" width="100" height="100" fill="url(#dots-method)" data-id="element-240" />
      </svg>

      <div className="container-custom relative z-10" data-id="element-241">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="text-center mb-16 md:mb-24" data-id="element-242">
          <h2 className="text-[36px] md:text-[42px] text-white mb-6" data-id="element-243">
            Programul CRESC
          </h2>
          <p className="text-[16px] md:text-[18px] text-white/80 max-w-[800px] mx-auto" data-id="element-244">
            Un program în 5 pași prin care îți ghidez copilul de la întârziere
            la dezvoltare armonioasă, lucrând prin joc și conectare, în rutinele
            zilnice, fără tehnici complicate și fără jucării scumpe.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-8 md:gap-6 relative" data-id="element-245">
          {/* Elegant connecting curve for desktop */}
          <div className="hidden lg:block absolute top-[40px] left-[10%] w-[80%] h-[40px] border-t-2 border-dashed border-white/20 rounded-t-[40px] z-0" data-id="element-246"></div>

          {pillars.map((pillar, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} className="relative flex flex-col items-center text-center group z-10" data-id="element-247">
              <div className="relative w-20 h-20 rounded-full bg-brand-gold flex items-center justify-center mb-6 shadow-card-hover transform transition-transform duration-500 group-hover:scale-110 group-hover:rotate-3" data-id="element-248">
                <span className="font-playfair font-bold text-[36px] text-brand-navy" data-id="element-249">
                  {pillar.letter}
                </span>
                <div className="absolute -bottom-2 -right-2 w-10 h-10 rounded-full bg-white flex items-center justify-center shadow-sm border-2 border-brand-navy" data-id="element-250">
                  {pillar.icon}
                </div>
              </div>

              <h3 className="text-[20px] text-brand-gold mb-4 font-playfair tracking-wide" data-id="element-251">
                {pillar.title}
              </h3>

              <p className="text-[15px] text-white/80 leading-relaxed" data-id="element-252">
                {pillar.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}